/**
 * 상태 및 우선순위 한글 레이블 매핑
 */

export const STATUS_LABELS: Record<string, string> = {
  new: '신규',
  in_progress: '진행중',
  review: '검토중',
  on_hold: '보류됨',
  rejected: '거절됨',
  resolved: '해결됨',
  updated: '업데이트완료',
};

export const PRIORITY_LABELS: Record<string, string> = {
  low: '낮음',
  medium: '보통',
  high: '높음',
  critical: '긴급',
};

export const ROLE_LABELS: Record<string, string> = {
  pm: 'PM',
  developer: '개발자',
  qa: 'QA',
};

export function getStatusLabel(status: string): string {
  return STATUS_LABELS[status] || status;
}

export function getPriorityLabel(priority: string): string {
  return PRIORITY_LABELS[priority] || priority;
}

export function getRoleLabel(role: string): string {
  return ROLE_LABELS[role] || role;
}
